import React from "react"
import styles from './PageIntro.module.scss'

export default function PageIntro({title, icon, iconLabel, paragraphs}) {
    return (
        <>
            <h1 className={styles.title}>
                {icon && <span className={styles.icon} role="img" aria-label={iconLabel}>{icon}</span>}
                {title}
            </h1>
            <div className={styles.article}>
                {paragraphs.map((paragraph, index) => (
                    <p key={index} style={{'--index': index}}>{paragraph}</p>
                ))}
            </div>
        </>
    )
}
